export const parseIfJSON = (str) => {
  if (typeof str !== "string") return str;

  try {
    const parsed = JSON.parse(str);
    if (typeof parsed === "object" && parsed !== null) {
      return parsed;
    }
    return str;
  } catch (e) {
    return str;
  }
};
